import * as CONSTANTS from './constants'
import { resolveSyncResultNotice } from '../../utils/syncResultNotice'

export const changeSyncView = (payload) => {
  return async (dispatch) => {
    dispatch({
      type: CONSTANTS.CHANGE_CURRENT_SYNC_VIEW,
      payload,
    })
  }
}

export const beginSyncOperation = (kind) => ({
  type: CONSTANTS.SET_SYNC_OPERATION,
  payload: { kind, startedAt: Date.now() },
})

export const dismissSyncNotice = () => ({
  type: CONSTANTS.SET_SYNC_NOTICE,
  payload: null,
})

/**
 * Fim do "Sincronizar" sem pull de fazendas: avisa que não havia nada a enviar, que o envio
 * terminou ou o que ficou para trás. `pendingBefore`/`pendingAfter` são os resumos lidos antes e
 * depois do envio (QA HML U13: o resultado sai do que ficou pendente, não do `currentSync`).
 */
export const announceSyncResult =
  (pendingBefore, pendingAfter) => (dispatch) => {
    const notice = resolveSyncResultNotice(pendingBefore, pendingAfter)
    if (notice) {
      dispatch({
        type: CONSTANTS.SET_SYNC_NOTICE,
        payload: { id: Date.now(), ...notice },
      })
    }
  }
